/**
 * The server refuses a commission payment or adjustment carrying a fraction of
 * a cent (`CommissionPaymentService.EnsureWholeCents`). The two money dialogs
 * refuse it first, in the server's own words, so the person entering the
 * amount sees the reason beside the field rather than after sending it.
 * `wholeCents.test.ts` pins the sentence to the C#.
 */
export const WHOLE_CENTS_MESSAGE =
  "Enter the amount in dollars and cents, with no more than two decimal places.";

/** A dollar amount in whole cents, so two amounts compare exactly, without a
 *  floating-point tolerance. */
export function toCents(amount: number): number {
  return Math.round(amount * 100);
}

/** True when a dollar amount carries a fraction of a cent: 10.001 does, 10.01
 *  does not. Exact for any amount with two or fewer decimal places, because
 *  dividing a whole number of cents by 100 lands on the same double as reading
 *  the two-decimal amount itself. */
export function hasFractionOfACent(amount: number): boolean {
  return toCents(amount) / 100 !== amount;
}
